/** Shared decorative artwork for Library and the coach's study mission. */
export function StudyIllustration({ className }: { className?: string }) {
  return (
    <img
      src="/images/study/library-notebook-v3.webp"
      alt=""
      aria-hidden="true"
      width={480}
      height={320}
      className={className}
      decoding="async"
      draggable={false}
    />
  );
}

export default StudyIllustration;
